import { Component, Input } from '@angular/core';
import { NgClass } from '@angular/common';
import { CopyToClipboardComponent } from '../../../shared/components/copy-to-clipboard/copy-to-clipboard.component';

@Component({
  selector: 'app-candidate-drug',
  templateUrl: './candidate-drug.component.html',
  styleUrls: ['./candidate-drug.component.scss'],
  imports: [NgClass, CopyToClipboardComponent]
})
export class CandidateDrugComponent {
  @Input() candidate: {
    drugDescription: string;
    ndc: string,
    flaggedForEsp: boolean,
    hrsaRebateNdc: boolean
  };
  @Input() wrapDrugName = false;
  @Input() showCopy = false;
  @Input() displayFlaggedForEsp = false;
  @Input() displayHrsaRebateNdc = false;

  constructor() {}

  public get isFlaggedForEsp(): boolean {
    return this.displayFlaggedForEsp && this.candidate.flaggedForEsp;
  }

  public get showHrsaRebateNdcIndicator(): boolean {
    return this.displayHrsaRebateNdc && this.candidate.hrsaRebateNdc;
  }
}
